import React from "react";

import {
  Toolbar,
  makeStyles,
  Box,
  AppBar,
  Container,
} from "../materials/helper";

import ChalanLogo from "../../../assests/icons/ChallanBkash";

import { useNavigation } from "../../../hooks/useNavigation";
import { useLocationPath } from "../../../hooks/useLocation";

import {
  dispatchMapperArray,
  propMapperArray,
  routes,
} from "../../../data/constants";
import connector from "../../../utils/reduxConnect/connector";
import ChallanTab from "../materials/Tab/ChallanTab";
import { pages } from "../../../data/metadata/tabsMetadata";
import ChallanAvatar from "../materials/ChallanAvatar/index";
import ChallanMenu from "../materials/Menu/ChallanMenu";
import { settingsNav } from "../../../data/metadata/menuMetaData";
import { logout } from "../../../services";
import Notifications from "../../../utils/notifications";

const compIdf = "TopNav";
const tabIdxIdentifier = {
  [routes.base]: 0,
  [routes.users]: 1,
};

function ResponsiveAppBar({
  username,
  logOut,
  navigateTo,
  pathname,
  credentials,
}) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [tabIndex, setTabIndex] = React.useState(tabIdxIdentifier[pathname]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const formatGrantType = (grantType) => {
    if (grantType === "report_viewer") return "Report Viewer";
    if (grantType === "system_admin") return "Admin";
    return "Admin";
  };

  return (
    <AppBar position="fixed" style={{ background: "#FFFFFF" }}>
      <Container maxWidth="xl">
        <Toolbar>
          <ChalanLogo />
          <ChallanTab
            config={pages(navigateTo, routes, credentials)}
            tabIndex={tabIndex}
            onTabChange={handleTabChange}
          />

          <Box sx={{ flexGrow: 0, display: "flex", alignItems: "center" }}>
            <div
              style={{
                margin: "0px 16px",
                color: "rgba(54, 43, 115, 1)",
                textAlign: "initial",
              }}
            >
              <h1 style={{ fontSize: 16, margin: 0 }}>{username}</h1>
              <p style={{ fontSize: 12, margin: 0 }}>
                {formatGrantType(credentials?.grant_type)}
              </p>
            </div>
            <ChallanAvatar username={username} />

            <ChallanMenu
              settings={settingsNav(logOut)}
              handleOpenUserMenu={handleOpenUserMenu}
              anchorElUser={anchorElUser}
              handleCloseUserMenu={handleCloseUserMenu}
            />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

const useStyles = (pathname) =>
  makeStyles((theme) => ({
    mainContent: {
      padding: theme.spacing(pathname === routes.signin ? 0 : 8, 0),
    },
  }));

function TopNav(props) {
  const navigateTo = useNavigation();
  const location = useLocationPath();
  const classes = useStyles(location.pathname)();

  const logOut = async () => {
    Notifications.activity("Signing out...");
    const { data, error } = logout({
      refreshToken: props.credentials.refresh_token,
    });

    Notifications.clear();
    if (!error) {
      Notifications.success("Succesfully signed out!");
      props.signOut();
      navigateTo(routes.signin);
    } else {
      Notifications.error(data.message);
    }
  };

  const formatUserName = (username) => {
    return username
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <React.Fragment>
      {location.pathname !== routes.signin && (
        <ResponsiveAppBar
          logOut={logOut}
          username={formatUserName(props.username)}
          navigateTo={navigateTo}
          pathname={location.pathname}
          credentials={props.credentials}
        />
      )}
      <main className={classes.mainContent}>{props.children}</main>
    </React.Fragment>
  );
}

export default connector(
  propMapperArray[compIdf],
  dispatchMapperArray[compIdf]
)(TopNav);
